<template>
    <v-col class="model-tours">
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn">
                <h1>{{ $t("tours_models.new_edit_tours_models") }}</h1>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_tours_models">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("tours_models.infos_tour_models") }}</h2>
                            <span class="trait"></span>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="selectedType"
                                    :disabled="is_validated"
                                    :items="sortedTypes"
                                    :label="$t('tours_models.type')"
                                    :loading="loadingTourTypes"
                                    dense
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                    @change="handleTypeChange"
                                >
                                    <template #item="{ item }">
                                        {{ item.designation }}
                                    </template>
                                    <template #selection="{ item }">
                                        {{ item.designation }}
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="selectedSite"
                                    :disabled="
                                        selectedType === null || is_validated
                                    "
                                    :items="sortedSites"
                                    :label="$t('tours_models.start_site')"
                                    :loading="loadingSites"
                                    dense
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                    @change="handleSiteChange"
                                >
                                    <template #item="{ item }">
                                        {{ item.label }} ({{ item.code }})
                                    </template>
                                    <template #selection="{ item }">
                                        {{ item.label }} ({{ item.code }})
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="selectedModelNumber"
                                    :disabled="
                                        modelNumbers.length === 0 ||
                                        is_validated
                                    "
                                    :items="sortedModelNumbers"
                                    :label="$t('tours_models.number_model')"
                                    :loading="loadingModelNumbers"
                                    dense
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                >
                                    <template #item="{ item }">
                                        {{ item.code }}
                                    </template>
                                    <template #selection="{ item }">
                                        {{ item.code }}
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="selectedDriver"
                                    :items="sortedDrivers"
                                    :label="$tc('tours_models.drivers', 1)"
                                    :loading="loadingDrivers"
                                    dense
                                    hide-details="auto"
                                    item-text="id"
                                    item-value="id"
                                    light
                                    outlined
                                >
                                    <template #item="{ item }">
                                        {{ item.firstname }} {{ item.lastname }}
                                    </template>
                                    <template #selection="{ item }">
                                        {{ item.firstname }} {{ item.lastname }}
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col>
                                <v-checkbox
                                    v-model="checkboxOrder"
                                    :label="$t('tours_models.customers_order')"
                                    class="mt-0"
                                    color="primary"
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col v-if="!is_validated" class="text-lg-right">
                                <v-btn
                                    :disabled="selectedModelNumber === null"
                                    class="btn-default"
                                    elevation="0"
                                    @click="validatedHeaders"
                                >
                                    {{ $t("global.validate") }}
                                </v-btn>
                            </v-col>
                            <v-col v-if="is_validated" class="text-lg-right">
                                <v-btn
                                    class="btn-cancel"
                                    elevation="0"
                                    @click="reinitializedHeaders"
                                >
                                    {{ $t("global.cancel") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="wrap-detail-element wrap-client">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h2>{{ $tc("tours_models.customers", 2) }}</h2>
                            <span class="trait"></span>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col v-if="is_validated" class="info-order"
                                   cols="12">
                                {{ $t("tours_models.info_order") }}
                            </v-col>
                            <v-col v-else class="info-order" cols="12">
                                {{ $t("tours_models.info_order_unvalidated") }}
                            </v-col>
                        </v-row>
                        <v-row v-if="is_validated">
                            <v-col cols="12" md="6">
                                <div class="header-customer">
                                    <v-checkbox
                                        v-model="selectAll"
                                        :label="$t('global.select_all')"
                                        color="primary"
                                        dark
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        :label="$t('global.search')"
                                        append-icon="mdi-magnify"
                                        dark
                                        dense
                                        hide-details="auto"
                                        outlined
                                        single-line
                                    ></v-text-field>
                                </div>
                                <div class="list-group-customers">
                                    <draggable
                                        ref="lazyloading"
                                        :empty-insert-threshold="500"
                                        :list="customers"
                                        class="border"
                                        ghost-class="ghost"
                                        group="customers"
                                    >
                                        <transition-group
                                            :name="!drag ? 'flip-list' : null"
                                            type="transition"
                                        >
                                            <div
                                                v-for="(
                                                    element
                                                ) in filteredCustomers"
                                                :key="element.id"
                                                class="list-group-item"
                                            >
                                                <div class="details">
                                                    <div class="icons">
                                                        <v-icon>
                                                            mdi-drag-vertical
                                                        </v-icon>
                                                        <v-checkbox
                                                            v-model="customerInGroup"
                                                            :value="element.id"
                                                            color="primary"
                                                            hide-details="auto"
                                                            type="checkbox"
                                                        ></v-checkbox>
                                                    </div>
                                                    <div class="infos">
                                                        <span class="name">
                                                             {{ element.name }}
                                                                -
                                                            {{
                                                                element.ropach_id
                                                            }}
                                                        </span>
                                                        <span class="address">
                                                            {{
                                                                element.address_1
                                                            }}
                                                        </span>
                                                        <span class="address">
                                                            {{
                                                                element.address_2
                                                            }}
                                                        </span>
                                                        <span
                                                            class="zipcode-city"
                                                        >
                                                            {{
                                                                element.zipcode
                                                            }}
                                                            {{ element.city }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </v-col>

                            <v-col cols="12" md="6">
                                <div class="header-customer">
                                    <span class="title-total">
                                        {{ $t("tours_types.total") }}
                                    </span>
                                    <span class="nb-total">
                                        {{ selectedCustomers.length }}
                                    </span>
                                </div>
                                <div class="list-group-customers">
                                    <draggable
                                        :empty-insert-threshold="100"
                                        :list="selectedCustomers"
                                        class="border"
                                        group="customers"
                                        v-bind="dragOptions"
                                        @add="handleAddEvent"
                                    >
                                        <transition-group
                                            :name="!drag ? 'flip-list' : null"
                                            type="transition"
                                        >
                                            <div
                                                v-for="(
                                                    element, index
                                                ) in selectedCustomers"
                                                :key="element.id"
                                                class="list-group-item"
                                            >
                                                <div class="details">
                                                    <div class="icons">
                                                        <v-icon>
                                                            mdi-drag-vertical
                                                        </v-icon>
                                                    </div>
                                                    <div class="infos">
                                                        <span class="name">
                                                             {{ element.name }}
                                                            -
                                                            {{ element.ropach_id }}
                                                        </span>
                                                        <span class="address">
                                                            {{
                                                                element.address_1
                                                            }}
                                                        </span>
                                                        <span class="address">
                                                            {{
                                                                element.address_2
                                                            }}
                                                        </span>
                                                        <span
                                                            class="zipcode-city"
                                                        >
                                                            {{
                                                                element.zipcode
                                                            }}
                                                            {{ element.city }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="index">
                                                    {{ index + 1 }}
                                                </div>
                                                <div
                                                    class="icons-end"
                                                    @click="
                                                        removeFromSelected(
                                                            index,
                                                            element
                                                        )
                                                    "
                                                >
                                                    <v-icon>mdi-close</v-icon>
                                                </div>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="container-button">
                    <v-btn
                        :loading="loadingSave"
                        class="btn-default"
                        elevation="0"
                        @click="save"
                    >
                        {{ $t("global.save") }}
                    </v-btn>
                </div>
            </v-form>
        </div>
    </v-col>
</template>

<script>
import Draggable from "vuedraggable";
import tour_models from "../../../mixins/tour_models";

export default {
    name: "NewToursModels",
    components: {
        Draggable,
    },
    mixins: [tour_models],
    data() {
        return {
            is_validated: false,
        };
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
        sortedTypes() {
            return [...this.tourTypes].sort((a, b) => a.designation.localeCompare(b.designation));
        },
        sortedDrivers() {
            return [...this.drivers].sort((a, b) => a.firstname.localeCompare(b.firstname));
        },
        sortedSites() {
            return [...this.sites].sort((a, b) => a.label.localeCompare(b.label));
        },
        sortedModelNumbers() {
            return [...this.modelNumbers].sort((a, b) => a.code.localeCompare(b.code));
        }
    },
    mounted() {
        this.getTourTypes();
        this.getDrivers();
    },
    methods: {
        handleTypeChange() {
            this.loadingSites = true;
            this.$api.tour_types
                .getSites(this.selectedType)
                .then(({data: sites}) => {
                    this.sites = sites.data;
                    this.loadingSites = false;
                });
            this.selectedSite = null;
            this.selectedModelNumber = null;
        },
        handleSiteChange() {
            this.loadingModelNumbers = true;
            this.$api.tour_types
                .getSiteModelNumbers(this.selectedType, this.selectedSite)
                .then(({data: model_numbers}) => {
                    this.modelNumbers = model_numbers.data;
                    this.loadingModelNumbers = false;
                });
            this.selectedModelNumber = null;
        },
        reinitializedHeaders() {
            this.is_validated = false;
            this.customers = [];
        },
        async validatedHeaders() {
            this.is_validated = true;
            this.customers = [];
            this.customers = await (this.getCustomers({
                params: {
                    notInTypeId: this.selectedType,
                },
            }));
        },
        async getNextPage() {
            if (this.page <= this.lastPage) {
                this.page = this.page + 1
                const customers = await (this.getCustomers({
                    params: {
                        notInTypeId: this.selectedType,
                        page: this.page,
                        customer_search: this.search
                    },
                }))
                this.customers = this.customers.concat(customers)
            }
        },
        async getSearch() {
            this.page = 1
            this.customers = await (this.getCustomers({
                params: {
                    notInTypeId: this.selectedType,
                    page: this.page,
                    customer_search: this.search
                },
            }))
        }

    }
};
</script>
